import { cva } from 'class-variance-authority';

export const cvaRoot = cva(['TogglerSimpleStyles-cvaRoot', 'relative', 'block', 'cursor-pointer select-none']);

export const cvaInput = cva(['TogglerSimpleStyles-cvaInput', 'hidden', 'peer']);

export const cvaInner = cva([
  'TogglerSimpleStyles-cvaInner',
  'relative',
  'block',
  'py-1.1 px-1.6 pb-1.3',
  'text-bodyM',
  'bg-cMediumGreyOnWhite',
  'rounded-[1.6rem]',
  'transition-all duration-300',
  'peer-checked:pr-4 peer-checked:bg-cLightGreenBtn',
  'relative',
  'transition-all duration-300',
  'overflow-hidden',
  'before:pb-[120%] before:absolute before:left-[-10%] before:transform-gpu before:translate-y-[68%] before:scale-0 before:w-[120%] before:h-0 before:rounded-[50%]',
  'after:absolute after:top-0 after:left-0 after:transform-gpu after:translate-y-[-100%] after:w-full after:h-full after:transition-transform after:ease-button-after after:duration-500',
  'hnotdisable:before:translate-y-0 hnotdisable:before:scale-[1.2] hnotdisable:before:transition-transform hnotdisable:before:duration-400 hnotdisable:before:ease-button-before',
  'hnotdisable:after:translate-y-0 hnotdisable:after:[transition-duration:0.05s] hnotdisable:after:[transition-delay:0.4s] hnotdisable:after:transition-transform hnotdisable:after:ease-button-after',
  'before:bg-cLightGreenBtn after:bg-cLightGreenBtn',
]);

export const cvaClose = cva([
  'TogglerSimpleStyles-cvaClose',
  'absolute right-1.6 top-1.5',
  'w-1.6 h-1.6',
  'text-0',
  'p-0',
  'border-none outline-none',
  'cursor-pointer select-none',
  'opacity-0 duration-300 transition-opacity',
  'peer-checked:opacity-100',
  'z-[1]',
]);

export const cvaCloseIcon = cva(['TogglerSimpleStyles-cvaCloseIcon', 'w-1.6 h-1.6', '!fill-cBlack']);
